import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import AgregarPerimetroChecada from "./AgregarPerimetroChecada/AgregarPerimetroChecada";
import EditarPerimetroChecada from "./EditarPerimetroChecada/EditarPerimetroChecada";
import { secondsToHms } from "../../../Components/TimeConvertions";

const NOMBRES_DIAS = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];

class PerimetrosChecada extends Component {
    tableRef = null;
    state = {
        todosPerimetros: [],
        loading: false,
        valor: 1,
        modalAgregarPerimetroChecada: false,
        modalEditarPerimetroChecada: false,
        modalEditarPerimetroChecadaId: null,
    };
    consultarPerimetros(params) {
        this.setState({ loading: true });
        axios
            .post(
                "perimetrosChecada/selectTodosPerimetrosChecada",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    this.setState({ todosPerimetros: [] });
                } else {
                    this.setState({
                        todosPerimetros: res.data.data,
                        totalRecords: res.data.totalRecords || 0,
                    });
                }
            });
    }

    deshabilitarPerimetroChecada(value) {
        this.setState({ loading: true });
        axios
            .post(
                "perimetrosChecada/deshabilitarPerimetroChecada",
                { perimetroChecadaId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Perímetro deshabilitado");
                } else {
                    message.error("Sucedio un error y no se pudo deshabilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }
    habilitarPerimetroChecada(value) {
        this.setState({ loading: true });
        axios
            .post(
                "perimetrosChecada/habilitarPerimetroChecada",
                { perimetroChecadaId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Perímetro habilitado");
                } else {
                    message.error("Sucedio un error y no se pudo habilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    agregarPerimetroChecada() {
        this.setState({ modalAgregarPerimetroChecada: true });
    }
    cerrarAgregarPerimetroChecada() {
        this.setState({ modalAgregarPerimetroChecada: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
    editarPerimetroChecada(id) {
        this.setState({ modalEditarPerimetroChecada: true, modalEditarPerimetroChecadaId: id });
    }
    cerrarEditarPerimetroChecada() {
        this.setState({ modalEditarPerimetroChecada: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }

    render() {
        const columns = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                buscar: "serieNumero",
                render: (value, record) => `${record.serie} - ${record.numero}`,
                width: "6%",
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                buscar: "nombre",
                width: "15%",
            },
            {
                title: "Descripción",
                dataIndex: "descripcion",
                key: "descripcion",
                buscar: "descripcion",
                width: "20%",
            },
            {
                title: "Proyecto",
                dataIndex: "proyectoNombre",
                key: "proyectoNombre",
                width: "13%",
            },
            {
                title: "Precisión máx.",
                dataIndex: "precisionMaxMetros",
                key: "precisionMaxMetros",
                align: "center",
                render: (value) => (value != null ? `${value} m` : "—"),
                width: "8%",
            },
            {
                title: "Horario por defecto",
                dataIndex: "ventanaDefault",
                key: "ventanaDefault",
                width: "20%",
                render: (value) => {
                    if (!value?.dias?.length) return "Solo con horario";
                    const dias = [...value.dias].sort((a, b) => a - b).map((dia) => NOMBRES_DIAS[dia]).join(", ");
                    const inicio = secondsToHms(value.inicioSeg)?.format("HH:mm");
                    const fin = secondsToHms(value.finSeg)?.format("HH:mm");
                    return (
                        <div>
                            <div style={{ fontSize: "12px" }}>{dias}</div>
                            <div style={{ fontSize: "12px", color: "#666" }}>{inicio} - {fin}</div>
                        </div>
                    );
                },
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "8%",
                render: (value) => {
                    if (value === 1) return <Tag color="green">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
                    return "—";
                },
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "10%",
                render: (value, record) => {
                    let buttons = [];

                    if (this.props.permisoEditarPerimetroChecada) {
                        buttons.push(
                            <Tooltip
                                key={`editar-${record._id}`}
                                title="Editar Perímetro"
                                placement="top"
                                overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                            >
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<EditOutlined />}
                                    onClick={() => this.editarPerimetroChecada(record._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    if (this.props.permisoDeshabilitarPerimetroChecada) {
                        if (record.estado === 1) {
                            buttons.push(
                                <Popconfirm
                                    key={`deshabilitar-${record._id}`}
                                    title="¿Seguro que quieres deshabilitar este perímetro?"
                                    onConfirm={() => this.deshabilitarPerimetroChecada(record._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip
                                        title="Deshabilitar"
                                        placement="top"
                                        overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                    >
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            lima
                                            icon={<CheckCircleOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        } else {
                            buttons.push(
                                <Popconfirm
                                    key={`habilitar-${record._id}`}
                                    title="¿Seguro que quieres habilitar este perímetro?"
                                    onConfirm={() => this.habilitarPerimetroChecada(record._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip
                                        title="Habilitar"
                                        placement="top"
                                        overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                    >
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            rojo
                                            icon={<StopOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        }
                    }

                    return <div className="acciones-container">{buttons}</div>;
                }
            },
        ];


        return (
            <>
                <PageHeader
                    title="Perímetros de Checada"
                    subTitle="Zonas donde los empleados pueden checar desde la app"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            {window.innerWidth > 1000 &&
                                <>
                                    <SegmentedItem
                                        options={[{ label: 'Vigente', value: 1 }, { label: 'Deshabilitada', value: 2 }, { label: 'Todos', value: 3 }]}
                                        onChange={(value) => {
                                            if (this.tableRef) {
                                                this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                            }
                                            this.setState({ valor: value });
                                        }}
                                        value={this.state.valor}
                                    />
                                </>
                            }
                            {this.props.permisoAgregarPerimetroChecada && (
                                <ButtonItem
                                    type="primary"
                                    key="agregarPerimetroChecada"
                                    onClick={this.agregarPerimetroChecada.bind(this)}
                                >
                                    Agregar Perímetro
                                </ButtonItem>
                            )}
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    onFetchData={this.consultarPerimetros.bind(this)}
                    anadirValorFiltro={this.state.valor}
                    size="small"
                    onlyMineFilter
                    dataSource={this.state.todosPerimetros}
                    columns={columns}
                    scroll={{ x: "max-content" }}
                    filterStorageKey={"perimetrosChecada" + this.props.empresaId}
                    onRow={(record) => ({
                        onDoubleClick: () => {
                            if (this.props.permisoEditarPerimetroChecada) {
                                this.editarPerimetroChecada(record._id);
                            }
                        },
                    })}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                />
                <AgregarPerimetroChecada
                    visible={this.state.modalAgregarPerimetroChecada}
                    cerrarAgregarPerimetroChecada={this.cerrarAgregarPerimetroChecada.bind(this)}
                />
                <EditarPerimetroChecada
                    visible={this.state.modalEditarPerimetroChecada}
                    perimetroChecadaId={this.state.modalEditarPerimetroChecadaId}
                    cerrarEditarPerimetroChecada={this.cerrarEditarPerimetroChecada.bind(this)}
                />
            </>
        );
    }
}

// Sin permisos propios todavía: usa los de Relojes Checadores
const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoAgregarPerimetroChecada: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f0204f7899dda241377ce2")?.activado,
        permisoEditarPerimetroChecada: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f020627899dda241377ce3")?.activado,
        permisoDeshabilitarPerimetroChecada: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f020717899dda241377ce4")?.activado,
    };
};

export default connect(mapStateToProps)(PerimetrosChecada);
